// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import './assets/css/theme-default.scss'
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ajax from './service/ajax';
import common from './service/common'
import domain from './service/getDate'
import echarts from 'echarts';

Vue.use(ElementUI);


Vue.config.productionTip = false
Vue.prototype.$common=common  //全局引入公共方法
Vue.prototype.$domain=domain  //全局引入接口路径
Vue.prototype.$echarts = echarts //引入组件

Vue.prototype.$ajax=ajax   //全局引入ajax方法

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js